// extracted by mini-css-extract-plugin
export default {"HomeModuleContacts":"page_HomeModuleContacts__1PhR0","container":"page_container__1U9aD","box":"page_box__cDqBH","left":"page_left__xy0C7","rigth":"page_rigth__IqfZp"};